let prefix = '/api/delayEvent/kpis';

function getKpisEquipment(data) {
    return window.axios.get(prefix+'/general',{params:data});
}

export default {
    getKpisEquipment,
}